<block-ui message="Edit blockUI">
  <div [ngClass]="showInline ? '' : 'p-2 p-lg-4'">
    <form (ngSubmit)="saveForm()" [formGroup]="editForm" autocomplete="off" name="editForm" novalidate role="form">
      <div class="d-flex justify-content-between pb-2">
        <ng-content select="[page-top-left]"></ng-content>
        <ng-content select="[page-top-right]"></ng-content>
      </div>
      <div class="card border-0" [ngClass]="withoutPadding ? 'p-0' : 'p-4'">
        <ng-content select="[page-content]"></ng-content>
      </div>
      <div class="row" *ngIf="showFooter">
        <div class="col p-4">
          <div class="body-border">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <button (click)="previous($event)" *ngIf="showBack" class="btn btn-light btn-sm" type="button">
                  <fa-icon [icon]="'arrow-left'"></fa-icon>
                  <span class="d-none d-sm-inline" jhiTranslate="entity.action.back"> Back</span>
                </button>
                <button [disabled]="editForm.invalid || isSaving" *ngIf="showSave" class="btn btn-success btn-sm" type="submit">
                  <fa-icon [icon]="'save'"></fa-icon>
                  <span class="d-none d-sm-inline" jhiTranslate="entity.action.save">Save</span>
                </button>
              </div>
              <ng-content select="[page-actions]"></ng-content>
              <div class="flex-fill"></div>
              <div>
                <ng-content select="[page-right-actions]"></ng-content>
                <flw-auditing [record]="record"></flw-auditing>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</block-ui>
